import { render } from "./VFrappe.vue?vue&type=template&id=7398755f"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/VFrappe.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7398755f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7398755f', __exports__)) {
    api.reload('7398755f', __exports__)
  }
  
  module.hot.accept("./VFrappe.vue?vue&type=template&id=7398755f", () => {
    api.rerender('7398755f', render)
  })

}


export default __exports__